import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import Field from '../../../../../../1stlog-ui/src/components/Field'
import Select from '../../../../../../1stlog-ui/src/components/Select'

const SlaSelect = (props) => {
  const {} = props

  const options = lodash.map(global.servicelevels, (s) => ({
    value: s.name,
    label: `${s.description} (${s.name})`
  }))

  return (
    <div>
      <Field name="sla" label="Servicelevel">
        <Select options={options} direct />
      </Field>
    </div>
  )
}

export default SlaSelect
